export default "__VITE_ASSET__zgCcyLTt__"